export default {
  DemoMessageStart: 'DemoMessageStart',
};
